import {Form} from "antd";
import DG_Form from "../../../custom/data-entry/form";
import Content from "./content";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {getAccountById, updateAccount} from "../../../api/account";
import {getListWeighingStations} from "../../../api/weighingStation";
import {onReloadData} from "../../../redux/actions/layout/interaction/action";
import {mapDataRole} from "./common/mapDataRole";
import {RoleList} from "./common/roleList";
import Role from "./component/role";

const Update = ({id, role, onCancel}) => {

    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [form] = Form.useForm()
    const [status, setStatus] = useState("active")

    const mapData = (data) => {
        return {
            name: data.name,
            phoneNumber: data.phoneNumber,
            screenName: data.screenName,
            status: data.status,
            password: undefined,
            roleAll: !data.roleAll,
            roleList: data.roleList
        }
    }

    useEffect(() => {
        getAccountById(id).then(r => {
            form.setFieldsValue(mapData(r));
            setStatus(r.status)
            getListWeighingStations().then(res => {

                const list = mapDataRole(res)
                const roleListAll = RoleList.concat(list)

                if (r.roleList) {
                    const newState = roleListAll.map(obj => {
                        let res1 = r.roleList.filter(it => it.module === obj.module);
                        if (res1.length > 0) {
                            return {
                                ...obj,
                                id: res1[0].id,
                                roleView: res1[0].roleView,
                                roleCreate: res1[0].roleCreate
                            };
                        }
                        return obj;

                    });

                    form.setFieldsValue(
                        {
                            roleList: newState
                        }
                    )
                } else {
                    form.setFieldsValue(
                        {
                            roleList: roleListAll
                        }
                    )
                }

            })
                .catch(() => {})
        })
            .catch(() => {})
    }, [form, id])

    const onFinish = (value) => {
        value = {
            ...value,
            roleAll: !value.roleAll,
            status: status
        }
        updateAccount( id, value).then(r => {
            onCancel(false)
            dispatch(onReloadData(!reloadData))
        })
            .catch(() => {})
    }

    return (
        <>
            <DG_Form
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >
                <Content role={role}
                         form={form}
                         status={status}
                         setStatus={(value) => setStatus(value ? "active" : "inactive")}
                         id={id}/>
                {
                    role !== "adminUser" && <Role form={form} />
                }

            </DG_Form>
        </>
    )
}

export default Update
